import React from "react";

import { Button } from "../../../atoms/Buttons/Base";
import { Text } from "../../../atoms/Text/Text";
import { User } from "../../../models/User";
import classNames from "classnames";
import FriendService from "../../../services/Friend/FriendService";
import FriendApiService from "../../../services/Friend/FriendApiService";

import styles from "./SendInvitePopup.css";

type InvitationLoggedInProps = {
  user: User;
  onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onLoadContent: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
};

export class InvitationForLoggedInPopup extends React.Component<InvitationLoggedInProps> {
  static displayName = "InvitationForLoggedInPopup";
  state = {
    invitingPersonName: "",
  };

  async loadInvitingPersonName() {
    const guid = FriendService.getInvitationGuidFromUrl(
      FriendService.friendGuid
    );
    const invitingPerson = await FriendApiService.getInviteInfo(guid);

    this.setState({
      invitingPersonName: invitingPerson.userName,
    });

    if (
      !this.state.invitingPersonName ||
      !this.state.invitingPersonName.length
    ) {
      this.props.onClose(null);
    }

    this.props.onLoadContent(null);
  }

  componentDidMount() {
    this.loadInvitingPersonName();
  }

  accept() {
    FriendService.redirectToLoginAndAcceptFriend();
  }

  render() {
    if (
      !this.state.invitingPersonName ||
      !this.state.invitingPersonName.length
    ) {
      return null;
    }
    const { user } = this.props;

    return (
      <React.Fragment>
        <Text
          className={styles.coverHeaderInfo}
          bold={true}
          size="h3"
          align="center"
        >
          An invitation from
        </Text>

        <Text
          bold={true}
          size="xxl"
          align="center"
          className={classNames(styles.userNameInvitor, styles.coverTitleInfo)}
        >
          {" "}
          {this.state.invitingPersonName}{" "}
        </Text>

        <Text
          size="xl"
          align="center"
          className={styles.coverTitleInfo}
          margin="16px 0 5px 0 "
        >
          You're invited to join my private network of friends on AARP Games.
          <br />
          We can share scores and in the future we'll be able to participate in
          challenges, send kudos and more!
          <br />
          Accept this invite and then we can connect.
        </Text>

        <Button
          className={classNames(styles.buttonYesNoLong, styles.buttonFriend)}
          onClick={this.accept}
        >
          <Text bold={true} size="sm" style={{ padding: "5px" }}>
            Accept
          </Text>
        </Button>

        <Button className={styles.buttonNoThanks} onClick={this.props.onClose}>
          <Text size="lg">No thanks</Text>
        </Button>
      </React.Fragment>
    );
  }
}
